// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var ReactRender = require("../../../reason/utils/ReactRender.bs.js");
var Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Form__TextAreaField = require("../../../uikit/reason/atoms/Form/Form__TextAreaField.bs.js");
var InlineWarning__Jsx3 = require("../../../uikit/reason/atoms/InlineWarning/InlineWarning__Jsx3.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var MarkBuyerNeedAsPurchasedDialogMutation_graphql = require("../../../__generated__/MarkBuyerNeedAsPurchasedDialogMutation_graphql.bs.js");

var convertVariables = MarkBuyerNeedAsPurchasedDialogMutation_graphql.Internal.convertVariables;

var convertResponse = MarkBuyerNeedAsPurchasedDialogMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = MarkBuyerNeedAsPurchasedDialogMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MarkBuyerNeedAsPurchasedDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, MarkBuyerNeedAsPurchasedDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

var MarkBuyerNeedPurchasedMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function MarkBuyerNeedAsPurchased(props) {
  var close = props.close;
  var nodeId = props.nodeId;
  var match = use();
  var mutate = match[0];
  var match$1 = React.useState(function () {
        return "";
      });
  var setComment = match$1[1];
  var comment = match$1[0];
  var match$2 = React.useState(function () {
        return "Idle";
      });
  var setSubmissionStatus = match$2[1];
  var submissionStatus = match$2[0];
  var resetForm = function () {
    setSubmissionStatus(function (param) {
          return "Idle";
        });
    setComment(function (param) {
          return "";
        });
  };
  var handleMarkingPurchasedSuccess = function () {
    close();
    resetForm();
  };
  return JsxRuntime.jsx(DialogV5.make, {
              title: "Mark buyer need as purchased",
              isOpen: props.isOpen,
              ariaLabel: "Mark buyer need as purchased",
              onDismiss: (function () {
                  close();
                }),
              size: "Large",
              children: JsxRuntime.jsx("form", {
                    children: JsxRuntime.jsxs(ViewStack.make, {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: "Once this buyer need is marked as purchased, it will no longer be active for new matches on TAN. The new TAN status and your comments will show to TAN members on existing matches."
                                }),
                            JsxRuntime.jsx(Form__TextAreaField.make, {
                                  labelText: "Comments",
                                  optionalText: "optional",
                                  onChange: (function (evt) {
                                      var value = evt.target.value;
                                      setComment(value);
                                    }),
                                  value: comment
                                }),
                            (function (__x) {
                                  return ReactRender.ifTrue(JsxRuntime.jsx(InlineWarning__Jsx3.make, {
                                                  children: "There was a problem updating the buyer need. Please try again."
                                                }), __x);
                                })(submissionStatus === "SubmissionError"),
                            JsxRuntime.jsxs(ViewStack.make, {
                                  mt: "lg",
                                  space: "sm",
                                  justifyContent: "flexEnd",
                                  flexDirection: "row",
                                  children: [
                                    JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                          onClick: (function (param) {
                                              close();
                                            }),
                                          disabled: submissionStatus === "Loading",
                                          size: "medium",
                                          _type: "button",
                                          children: "Cancel"
                                        }),
                                    JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                          disabled: submissionStatus === "Loading",
                                          children: "Mark as purchased"
                                        })
                                  ]
                                })
                          ]
                        }),
                    onSubmit: (function ($$event) {
                        $$event.preventDefault();
                        setSubmissionStatus(function (param) {
                              return "Loading";
                            });
                        mutate({
                              input: {
                                comment: Form__Helpers.opt_of_string(comment),
                                nodeId: nodeId
                              }
                            }, undefined, undefined, undefined, (function (param, param$1) {
                                var markBuyerNeedPurchased = param.markBuyerNeedPurchased;
                                if (markBuyerNeedPurchased !== undefined) {
                                  if (markBuyerNeedPurchased.__typename === "BuyerNeedMarkedPurchased") {
                                    return handleMarkingPurchasedSuccess();
                                  } else {
                                    return setSubmissionStatus(function (param) {
                                                return "SubmissionError";
                                              });
                                  }
                                } else {
                                  return setSubmissionStatus(function (param) {
                                              return "SubmissionError";
                                            });
                                }
                              }), (function (param) {
                                setSubmissionStatus(function (param) {
                                      return "SubmissionError";
                                    });
                              }), undefined);
                      })
                  })
            });
}

var make = MarkBuyerNeedAsPurchased;

exports.MarkBuyerNeedPurchasedMutation = MarkBuyerNeedPurchasedMutation;
exports.make = make;
/* commitMutation Not a pure module */
